<template>
  <v-tooltip
    :top="top"
    :bottom="bottom"
    :left="left"
    :right="right"
    :open-on-hover="false"
    open-on-click
  >
    <template #activator="{ on, attrs }">
      <span
        v-bind="attrs"
        v-on="on"
        class="text-caption"
        style="opacity:.6"
        @dblclick.once="debug()"
      >
        v{{ Version.short }}
      </span>
    </template>
    v{{ Version.long }}
  </v-tooltip>
</template>

<script>
  import Version from '@/version.json'

  export default {
    props: {
      top: {
        required: false,
        type: Boolean,
        default: false,
      },
      bottom: {
        required: false,
        type: Boolean,
        default: false,
      },
      left: {
        required: false,
        type: Boolean,
        default: false,
      },
      right: {
        required: false,
        type: Boolean,
        default: false,
      },
    },

    data: () => ({
      Version,
    }),

    methods: {
      debug () {
        AndroidDevice.debug()
      },
    },
  }
</script>
